import rootInstance from "@/services/root.js";

export default function() {
	rootInstance.defaults.baseURL = process.env.MIX_CIRCLES_API_BASE_URI + "/api/v1";
	return rootInstance;
}
